import React from "react";
import JobMangComp from "../../components/JobManagement/JobMangComp";

const JobManagement = () => {
  return (
    <>
      <JobMangComp />
    </>
  );
};

export default JobManagement;
